import React from 'react';
import { FormBuilder, Loader, EMPTY_ARRAY } from 'commons-ui';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationCreateSchema } from '../../utils/formConfig';

import useCreate from './useCreate';

const CreateWallet: React.FC<{}> = () => {
	const { data, handleFormSubmit, handleFormCancel, setShowLoader, showLoader } = useCreate();
	return (
		<>
			{showLoader && <Loader />}
			<FormBuilder
				data={data}
				mode='create'
				showLoader={false}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				validationSchema={validationCreateSchema}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				dependencies={EMPTY_ARRAY}
			/>
		</>
	);
};

export default CreateWallet;
